/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'factory': {
    width: 16,
    height: 16,
    viewBox: '0 0 54.303 54.303',
    data: '<path pid="0" d="M51.687 43.313l-1.72-36.849H38.788l-1.224 36.849H34.33l.645-19.394h-5.236v-8.404l-13.576 8.404v-8.404L1.939 23.919v19.394H0v4.525h54.303v-4.525h-2.616zm-39.404-6.464H7.758v-4.525h4.525v4.525zm7.757 0h-4.525v-4.525h4.525v4.525zm7.758 0h-4.525v-4.525h4.525v4.525z"/>'
  }
})
